import styled from "styled-components";

export const ContainerBox = styled.div`
    position: relative;  
    margin: 1rem;
    padding: 2em 2em 4rem 2rem;
    border-radius: 1rem;
    background-color: ${props => props.theme.colors.backgroundLight};
    color: ${props => props.theme.colors.text};
    user-select: none;
    
    /* The weird gradient */
    &:after { 
      content: " ";
      background: radial-gradient(to top, rgb(255 255 255 / 20%) 14%, transparent 75%, transparent);
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 5rem;
    }
    
    /* The weird line at the bottom */
    &:before { 
      content: " ";
      background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 50%, rgba(0,212,255,0) 100%);
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1px;
    }
`;